import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ubicacion-categoria',
  templateUrl: './ubicacion-categoria.component.html',
  styleUrls: ['./ubicacion-categoria.component.css']
})
export class UbicacionCategoriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
